export default __webpack_public_path__ + "static/messina-messenger-header-8f2b7869b2120d0ef80c85c21c545345.png";